export default __webpack_public_path__ + "static/media/Photo 4 - MR - volets fermés.98edf58d.png";